module.exports = __webpack_public_path__ + "img/nk-jemisin.57b5ac04.png";